import PropTypes from "prop-types";
import useSmsKillSwitch from "shared/hooks/useSmsKillSwitch";

const SmsKillSwitchWrapper = ({ children }) => {
	const { disableSms } = useSmsKillSwitch();

	if (disableSms) {
		return null;
	}

	return children;
};

SmsKillSwitchWrapper.propTypes = {
	children: PropTypes.element.isRequired,
};

export default SmsKillSwitchWrapper;



// WEBPACK FOOTER //
// ./src/shared/components/SmsKillSwitchWrapper.jsx